import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { Guid } from 'tessa/platform';
import { CdCardTypes } from '../Helpers/CdCardTypes';
import { CdUIHelper } from './CdUIHelper';
import { GridRowAction, GridViewModel } from 'tessa/ui/cards/controls';
import { reaction, runInAction } from 'mobx';
import { CardRow } from 'tessa/cards';
import { ArrayStorage } from 'tessa/platform/storage';
import { openCard } from 'tessa/ui/uiHost';

export class CdProjectUIExtension extends CardUIExtension {
  private _disposerSelectRow: Function | null = null;
  private _disposerCardRowTepsVirtual: ArrayStorage<CardRow> | undefined | null = null;
  public finalized() {
    // подчищаем за собой
    if (this._disposerCardRowTepsVirtual) {
        this._disposerCardRowTepsVirtual = null;
    }
    // подчищаем за собой
    if (this._disposerSelectRow) {
        this._disposerSelectRow();
        this._disposerSelectRow = null;
    }
}
  public initialized(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.ProjectTypeID)) {
    return;
    }
    let tepInfoVirtual = context.card.sections.tryGet("IrdDocTEPsInfoVirtual");

    this._disposerCardRowTepsVirtual = context.card.sections.tryGet("IrdDocTEPsInfoVirtual")?.clone().rows;

    for (let rowToDelete of tepInfoVirtual!.rows) {
      tepInfoVirtual!.rows.remove(rowToDelete);
    }
    tepInfoVirtual?.rows.clear();

    // TODO вроде небыло в вебе
    let irdVersions = CdUIHelper.GetUIControl<GridViewModel>(context, "IrdVersions");
    let irdTeps = CdUIHelper.GetUIControl<GridViewModel>(context, "IrdTeps");

        // подписываемся на клик
        if (this._disposerSelectRow == null) {
          this._disposerSelectRow = reaction(() => irdVersions!.selectedRow, () => {
              let cardRowViewModel = irdVersions!.selectedRow;
              if (cardRowViewModel != null) {
                  if (cardRowViewModel.isSelected === true) {
                    const teps = context.card.sections.tryGet("IrdDocTEPsInfoVirtual");
                    for (let rowToDelete of teps!.rows) {
                      teps!.rows.remove(rowToDelete);
                    }
                    teps?.rows.clear();
                    let row = cardRowViewModel.row;
                      if (row != null && row.rowId != null) {
                        runInAction(() => {
                        let show = this._disposerCardRowTepsVirtual?.filter(x => x.getField("TepDocID")?.$value === row.getField("IrdVersionID")?.$value);
                        show!.forEach(el => {
                          teps?.rows.add(el);
                        });
                      });
                      }
                  }
              }
          });
        }
          irdVersions?.rowInvoked.add(async e => {
            const docID = e.action === GridRowAction.Opening && e.row.tryGet('IrdVersionID');
            if (docID !== Guid.empty && docID !== undefined) {
                e.cancel = true;
                await openCard({
                    cardId: docID
                  });
                return;
            }
        });
        irdTeps?.rowInvoked.add(async e => {
          const docID = e.action === GridRowAction.Opening && e.row.tryGet('TepID');
          if (docID !== Guid.empty && docID !== undefined) {
              e.cancel = true;
              await openCard({
                  cardId: docID,
                  cardTypeId: CdCardTypes.IrdTEPTypeID,
                  cardTypeName: CdCardTypes.IrdTEPTypeName
                });
              return;
          }
      });
  }
}